const TABS = [
  { id: 'policies', label: 'POLICIES' },
  { id: 'draft-policies', label: 'DRAFT POLICIES' },
  { id: 'channels', label: 'CHANNELS' },
];

export default function NavBar({ activeTab, onTabChange }) {
  return (
    <nav className="nav-bar" aria-label="Main">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={
            tab.id === activeTab ? 'nav-tab nav-tab--active' : 'nav-tab'
          }
          aria-current={tab.id === activeTab ? 'page' : undefined}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}
